import { cn } from '@/lib/utils'
import type * as React from 'react'

type BadgeVariant = 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline'

const variants: Record<BadgeVariant, string> = {
  default: 'bg-[#4a2f21]/10 text-[#4a2f21]',
  secondary: 'bg-slate-100 text-slate-700',
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100 text-amber-800',
  destructive: 'bg-rose-100 text-rose-700',
  outline: 'border border-slate-200 bg-white text-slate-700',
}

export function Badge({
  className,
  variant = 'default',
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { variant?: BadgeVariant }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium',
        variants[variant],
        className,
      )}
      {...props}
    />
  )
}
